/**
 * Splide carousel for header search "Crystals A–Z" strip.
 * Splide hides the track until mounted; we destroy on close so each open gets a fresh mount.
 */
(function () {
  var SPLIDE_JS = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';

  function loadSplideJs(cb) {
    if (typeof window.Splide !== 'undefined') return cb();
    var existing = document.querySelector('script[data-search-popdown-splide-js]');
    if (existing) {
      if (typeof window.Splide !== 'undefined') {
        cb();
      } else {
        existing.addEventListener('load', cb);
      }
      return;
    }
    var s = document.createElement('script');
    s.src = SPLIDE_JS;
    s.async = false;
    s.setAttribute('data-search-popdown-splide-js', '1');
    s.onload = cb;
    document.head.appendChild(s);
  }

  function destroySplide(host) {
    var root = host.querySelector('[data-search-crystals-splide]');
    if (!root || !root._searchCrystalsSplideInstance) return;
    try {
      root._searchCrystalsSplideInstance.destroy();
    } catch (e) {
      /* noop */
    }
    root._searchCrystalsSplideInstance = null;
    root.classList.remove('is-initialized');
  }

  function mount(host) {
    var root = host.querySelector('[data-search-crystals-splide]');
    if (!root) return;

    destroySplide(host);

    var prevBtn = host.querySelector('[data-search-crystals-prev]');
    var nextBtn = host.querySelector('[data-search-crystals-next]');

    loadSplideJs(function () {
      if (!window.Splide || !root.isConnected) return;

      var idx = parseInt(root.getAttribute('data-active-index') || '0', 10);
      if (isNaN(idx) || idx < 0) idx = 0;

      var splide;
      try {
        splide = new window.Splide(root, {
          type: 'slide',
          perPage: 5,
          gap: '0.55rem',
          focus: 'center',
          pagination: false,
          arrows: false,
          rewind: false,
          trimSpace: false,
          breakpoints: {
            /* Two-column browse (tablet / small laptop): narrow track — fewer slides avoids overlap */
            1399: {
              perPage: 4,
              gap: '0.5rem',
            },
            1100: {
              perPage: 3,
              gap: '0.55rem',
            },
            /* Mobile: fewer slides per view + more room per cell */
            749: {
              perPage: 3,
              gap: '0.55rem',
            },
          },
        });
      } catch (e) {
        root.classList.add('search-popdown__splide--fallback');
        return;
      }

      function jumpToActive() {
        try {
          splide.go(idx);
        } catch (e2) {
          /* noop */
        }
      }

      splide.on('mounted', function () {
        jumpToActive();
        requestAnimationFrame(function () {
          jumpToActive();
        });
      });

      splide.on('resized', function () {
        jumpToActive();
      });

      try {
        splide.mount();
      } catch (e3) {
        root.classList.add('search-popdown__splide--fallback');
        return;
      }

      root._searchCrystalsSplideInstance = splide;

      /* Popdown was hidden until open — layout width can be wrong on first paint; refresh then re-center */
      setTimeout(function () {
        if (!root.isConnected || !root._searchCrystalsSplideInstance) return;
        try {
          splide.refresh();
          jumpToActive();
        } catch (e4) {
          /* noop */
        }
      }, 60);

      if (prevBtn) {
        prevBtn.onclick = function () {
          splide.go('<');
        };
      }
      if (nextBtn) {
        nextBtn.onclick = function () {
          splide.go('>');
        };
      }

      /* Mobile: keep the search field from stealing focus while interacting with the A–Z strip (keyboard / zoom issues). */
      var hostEl = root.closest('header-search-popdown');
      if (hostEl) {
        var mqMobile = window.matchMedia('(max-width: 749px)');
        var searchInput = hostEl.querySelector('.search-popdown input[type="search"]');
        var wrap = hostEl.querySelector('.search-popdown__splide-wrap');
        var azTouchActive = false;
        var azTouchClearTimer;

        function blurPopdownSearch() {
          if (!mqMobile.matches) return;
          if (searchInput && document.activeElement === searchInput) {
            searchInput.blur();
          }
        }

        function markAzTouchEnd() {
          clearTimeout(azTouchClearTimer);
          azTouchClearTimer = setTimeout(function () {
            azTouchActive = false;
          }, 500);
        }

        if (wrap) {
          wrap.addEventListener(
            'touchstart',
            function () {
              if (!mqMobile.matches) return;
              azTouchActive = true;
              blurPopdownSearch();
            },
            { passive: true }
          );
          wrap.addEventListener('touchend', markAzTouchEnd, { passive: true });
          wrap.addEventListener('touchcancel', markAzTouchEnd, { passive: true });
        }

        if (searchInput) {
          hostEl.addEventListener(
            'focusin',
            function (e) {
              if (!mqMobile.matches) return;
              if (e.target !== searchInput || !azTouchActive) return;
              requestAnimationFrame(function () {
                if (document.activeElement === searchInput) {
                  searchInput.blur();
                }
              });
            },
            true
          );
        }
      }
    });
  }

  function bindBrowseHideOnQuery(host) {
    if (host._browseQueryBound) return;
    var layout = host.querySelector('.search-popdown__layout');
    var browse = host.querySelector('.search-popdown__browse');
    var input = host.querySelector('.search-popdown input[type="search"]');
    if (!layout || !browse || !input) return;
    host._browseQueryBound = true;

    function updateBrowseVisibility() {
      var hasQuery = input.value.trim().length > 0;
      var hadQuery = layout.classList.contains('search-popdown__layout--has-query');
      layout.classList.toggle('search-popdown__layout--has-query', hasQuery);
      if (hadQuery && !hasQuery) {
        var splideRoot = host.querySelector('[data-search-crystals-splide]');
        var inst = splideRoot && splideRoot._searchCrystalsSplideInstance;
        if (inst) {
          try {
            inst.refresh();
          } catch (e) {
            /* noop */
          }
        }
      }
    }

    input.addEventListener('input', updateBrowseVisibility);
    input.addEventListener('change', updateBrowseVisibility);
    var form = input.form;
    if (form) {
      form.addEventListener('reset', function () {
        setTimeout(updateBrowseVisibility, 0);
      });
    }

    var details = host.querySelector('details');
    if (details) {
      details.addEventListener('toggle', function () {
        if (details.open) {
          requestAnimationFrame(updateBrowseVisibility);
        }
      });
    }

    updateBrowseVisibility();
  }

  function bind(host) {
    bindBrowseHideOnQuery(host);

    var details = host.querySelector('details');
    if (!details || details._searchCrystalsSplideBound) return;
    details._searchCrystalsSplideBound = true;

    details.addEventListener('toggle', function () {
      if (!details.open) {
        destroySplide(host);
        return;
      }
      requestAnimationFrame(function () {
        mount(host);
      });
    });
  }

  function init() {
    document.querySelectorAll('header-search-popdown').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
